import { jsx } from 'react/jsx-runtime';
import { Icon } from '../components/internal/Icon.js';

function CodeIcon(props) {
  return /* @__PURE__ */ jsx(Icon, {
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "m7.5 6-4 4 4 4m5-8 4 4-4 4"
    })
  });
}

export { CodeIcon };
//# sourceMappingURL=Code.js.map
